import React, { useState, useEffect } from 'react'
// import * as ReactDOM from 'react-dom';
// import { makeStyles } from '@material-ui/core';

// import {
//   DataGrid, faIR,
//   GridToolbarContainer,
//   GridToolbarColumnsButton,
//   GridToolbarFilterButton,
//   GridToolbarExport,
//   GridToolbarDensitySelector,

// } from '@mui/x-data-grid';

// import Box from '@mui/material/Box';
import { SERVER } from '../../constants';
import { AUTH_TYPES } from '../../auth/authConstants';
// import * as XLSX from 'xlsx';
// import moment from 'moment-jalaali'
// import { ROLES } from '../../constants';
import {
  Brush,

  PieChart, Pie, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const color = ["#8884d8", "#82ca9d", "orange", "pink", "#ebc0ff","#8884d8", "#82ca9d", "orange", "pink", "#00ff0d", "#ebc0ff"]
const color2 = ["#84ced8", "#acca82", "#4c00ff", "#ffc0f8", "#ebc0ff","#8884d8", "#82ca9d", "orange", "pink", "#00ff0d", "#ebc0ff"]
const color3 = ["#84cad8", "#ca9c82", "#00ff0d", "#ebc0ff","#8884d8", "#82ca9d", "orange", "pink", "#00ff0d", "#ebc0ff"]

export const BiComponent = () => {
  // const classes = useStyles();

  // const { permissions } = usePermissions();

  // const [chartData, setChartData] = useState({ columns: [], rows: [] })
  const [reportData, setReportData] = useState({
    byNeedCategory:[],
    byCategory: [],
    byStatus: [],
    byUnit: [],
    bySenderUnit:[],
  });
  const [endpointCalled, setEndpointCalled] = useState(false);
  // const pinnedRows = {
  //   top: [{ id: 0 }],
  // };
  useEffect(() => {
    const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    const url = `${SERVER}/admin/reportneed`;
    fetch(url, {
      headers: new Headers({
        'Authorization': `${token}`,
      }),

    })
      .then((data) => data.json())
      // .then((data) => setTableRows(data.rows))
      // .then((data) => setChartData(data))
      // .then((data) => tableColumns= data.columns)
      .then((data) => {
        setReportData(data); // Assuming `result` contains `combinedReportData`

        setEndpointCalled(true)
      })


  }, [])
  return (


    <div style={{ width: '100%' }}>      {/* flexDirection:'row',alignItems:"stretch" */}
      <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
        {endpointCalled ?
          <>
            <MyBarChart width="100%" data={reportData.bySenderUnit} colors={color3} />

            <MyBarChart width="100%" data={reportData.byCategory} colors={['#FF5733', '#33FF57', '#3357FF']} />

            <MyBarChart width="100%" data={reportData.byStatus} colors={color} />

            <MyBarChart width="100%" data={reportData.byUnit} colors={color2} />
            {/* <MyBarChart width="50%" data={data} colors={color} />
            <MyLineChart width="50%" data={barData1} colors={color2} />
            <MyBarChart width="50%" data={barData1} colors={color3} /> */}
            <ResponsiveContainer width="50%" height={300}>
              <PieChart width="50%" height={400}>
                <Pie
                  dataKey="value"
                  isAnimationActive={true}
                  data={reportData.byNeedCategory}
                  cx="30%"
                  cy="50%"
                  outerRadius={80}
                  fill="#8884d8"
                  label />
                {/* <Pie dataKey="value" data={data02} cx="70%"
                  cy="50%" innerRadius={40} outerRadius={80} fill="#82ca9d" /> */}
                <Tooltip />
              </PieChart>
            </ResponsiveContainer></>
          : null}
      </div>
    </div >
  )
};


class MyBarChart extends React.Component {

  getBar = () => {
    const { stacked, colors, data } = this.props;
    if (!data || data.length === 0) return null; // Ensure data exists
    const keysArr = Object.keys(data[0]).slice(1); // Extract keys dynamically
    return keysArr.map((item, index) => (
      <Bar key={item} dataKey={item} stackId={stacked ? "a" : null} fill={colors[index]} barSize={50} />
    ));
  };

  modifyFormatter = (value, name, props) => {
    const nameJSX = (
      <span>
        <span
          style={{
            display: "inline-block",
            marginRight: "5px",
            borderRadius: "10px",
            width: "10px",
            height: "10px",
            backgroundColor: props.color,
          }}
        ></span>
        {name} : {value}
      </span>
    );
    return [nameJSX].reverse();
  };

  handleSort = (item1, item2) => {
    // Example: Sort alphabetically by name
    return item1.value.localeCompare(item2.value);
  };

  render() {
    const { width, data } = this.props;
    const xAxisKey = data?.length > 0 ? Object.keys(data[0])[0] : "xLabel"; // Fallback to "xLabel"

    return (
      <ResponsiveContainer width={width} height={300}>
        <BarChart
          width={500}
          height={300}
          data={data}
          barCategoryGap="0%"
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} vertical={false} />
          <XAxis dataKey={xAxisKey} />
          <YAxis axisLine={true} tickLine={true} />
          <Tooltip formatter={this.modifyFormatter} />
          <Legend />
          {this.getBar()}
          <Brush dataKey={xAxisKey}>
            <BarChart>{this.getBar()}</BarChart>
          </Brush>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
